import { httpClient } from './httpClient';

export interface PageBookmark {
  id: string;
  userId: string;
  caseId: string;
  documentId: string;
  pageNumber: number;
  note: string | null;
  color: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBookmarkRequest {
  caseId: string;
  pageNumber: number;
  note?: string;
  color?: string;
}

export interface UpdateBookmarkRequest {
  note?: string;
  color?: string;
}

export const bookmarkApi = {
  getBookmarksForCase: (caseId: string): Promise<PageBookmark[]> =>
    httpClient.get<PageBookmark[]>(`/documents/bookmarks/case/${caseId}`),

  getBookmarksForDocument: (documentId: string): Promise<PageBookmark[]> =>
    httpClient.get<PageBookmark[]>(`/documents/${documentId}/bookmarks`),

  createBookmark: (documentId: string, data: CreateBookmarkRequest): Promise<PageBookmark> =>
    httpClient.post<PageBookmark>(`/documents/${documentId}/bookmarks`, data),

  updateBookmark: (documentId: string, bookmarkId: string, data: UpdateBookmarkRequest): Promise<PageBookmark> =>
    httpClient.put<PageBookmark>(`/documents/${documentId}/bookmarks/${bookmarkId}`, data),

  deleteBookmark: (documentId: string, bookmarkId: string): Promise<void> =>
    httpClient.delete(`/documents/${documentId}/bookmarks/${bookmarkId}`),
};
